import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { FaRegTimesCircle } from "react-icons/fa";


import "./formModal.css";

const FormModal = ({ isRtl }) => {

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const [validated, setValidated] = useState(false);

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }

        setValidated(true);
    };

    return (
        <>
            <button type='button' className="ModalButton" onClick={handleShow}>
                {isRtl ? 'اطلب عرض تجريبي' : 'GET A FREE DEMO'}
            </button>

            <Modal show={show} centered className='formModal' onHide={handleClose}>
                {/* <Modal.Header closeButton>
                    <Modal.Title>Modal heading</Modal.Title>
                </Modal.Header> */}
                <Modal.Body>
                    <div>
                        <button type='button' className='closeButton' onClick={handleClose} >
                            <FaRegTimesCircle />
                        </button>
                        <div className="formBox">
                            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                <Row>
                                    <Form.Group as={Col} md="12" className="mb-4" controlId="validationCustom01">
                                        <Form.Label>{isRtl ? 'الاسـم الكـامل' : 'Full Name'}</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            placeholder={isRtl ? 'اكتب الاسم الكامل' : 'Enter your full name'}
                                        />
                                        {/* <Form.Control.Feedback>Looks good!</Form.Control.Feedback> */}
                                    </Form.Group>
                                    <Form.Group as={Col} md="12" className="mb-4" controlId="validationCustom02">
                                        <Form.Label>{isRtl ? 'البريد الإلكتروني' : 'Email Address'}</Form.Label>
                                        <Form.Control
                                            required
                                            type="email"
                                            placeholder={isRtl ? 'البريد الإلكتروني الخاص بالعمل' : 'Work email address'}
                                        />
                                        {/* <Form.Control.Feedback>Looks good!</Form.Control.Feedback> */}
                                    </Form.Group>
                                    <Form.Group as={Col} md="12" className="mb-4" controlId="validationCustom02">
                                        <Form.Label>{isRtl ? 'اسـم المنشـاة' : 'Company Name'}</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            placeholder={isRtl ? 'اكتب اسم المنشأة' : 'Enter the company name'}
                                        />
                                        {/* <Form.Control.Feedback>Looks good!</Form.Control.Feedback> */}
                                    </Form.Group>
                                    <Form.Group as={Col} md="12" className="mb-4" controlId="validationCustom02">
                                        <Form.Label>{isRtl ? 'رقم الهاتف المتحرك' : 'Mobile Number'}</Form.Label>
                                        <Form.Control
                                            required
                                            type="text"
                                            placeholder={isRtl ? 'اكتب رقم هاتفك المتحرك' : 'Enter your mobile number'}
                                        />
                                        {/* <Form.Control.Feedback>Looks good!</Form.Control.Feedback> */}
                                    </Form.Group>
                                </Row>
                                <button type="submit" className='submitbtn'>
                                    {isRtl ? 'طلب العرض التجريبي' : 'Request a Demo'}
                                </button>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
                {/* <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleClose}>
                        Save Changes
                    </Button>
                </Modal.Footer> */}
            </Modal>
        </>
    )
}

export default FormModal